export default __webpack_public_path__ + "static/media/15.f9008375.jpg";